import { render, staticRenderFns } from "./SuggestionListBlockItem.vue?vue&type=template&id=84ea7e72&scoped=true&"
var script = {}
import style0 from "./SuggestionListBlockItem.vue?vue&type=style&index=0&id=84ea7e72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ea7e72",
  null
  
)

export default component.exports